import React from 'react';
import { Box } from '@mui/material';
import { spacing } from '../../../constants';
import SectionCard from '../raiseQueryForm/SectionCard';
import EditQueryInputField from './EditQueryInputField';
import EditQueryAutocompleteField from './EditQueryAutocompleteField';
import { PRIORITIES } from '../../../constants/editQueryModal';
import { formatQueryProjectNameForDisplay } from '../../../utils/projectsUtils';

/**
 * EditQueryBasicInfoSection Component
 * Basic Information section for EditQueryModal
 * 
 * @param {Object} query - Query object
 * @param {Object} formData - Form data object
 * @param {Function} handleChange - Change handler
 * @param {Function} handlePriorityChange - Priority change handler
 * @param {Function} handleFocus - Focus handler
 * @param {Function} handleBlur - Blur handler
 * @param {Object} focusedFields - Focused fields state
 */
const EditQueryBasicInfoSection = ({
  query,
  projectsCatalog = [],
  formData,
  handleChange,
  handlePriorityChange,
  handleFocus,
  handleBlur,
  focusedFields,
}) => {
  const projectDisplay = formatQueryProjectNameForDisplay(query?.projectName, projectsCatalog);
  return (
    <SectionCard title="Basic Information">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
          gap: spacing.sm,
          width: '100%',
        }}
      >
        <Box>
          <EditQueryInputField
            label="Region"
            value={query?.region || 'N/A'}
            disabled={true}
            isFocused={focusedFields.region}
          />
        </Box>

        <Box>
          <EditQueryInputField
            label="Project Name"
            value={projectDisplay || 'N/A'}
            disabled={true}
            isFocused={focusedFields.projectName}
          />
        </Box>

        <Box sx={{ gridColumn: '1 / -1' }}>
          <EditQueryAutocompleteField
            label="Priority"
            options={PRIORITIES}
            getOptionLabel={(option) => option.label || ''}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            value={PRIORITIES.find((p) => p.value === formData.priority) || null}
            onChange={handlePriorityChange}
            onFocus={handleFocus('priority')}
            onBlur={handleBlur('priority')}
            isFocused={focusedFields.priority}
            placeholder="Type to search priority..."
            filterOptions={(options, params) => {
              const filtered = options.filter((option) =>
                option.label.toLowerCase().includes(params.inputValue.toLowerCase())
              );
              return filtered;
            }}
          />
        </Box>

        {/* <Box sx={{ gridColumn: '1 / -1' }}>
          <EditQueryInputField
            label="Report section"
            value={formData.visualDescription}
            onChange={handleChange('visualDescription')}
            onFocus={handleFocus('visualDescription')}
            onBlur={handleBlur('visualDescription')}
            disabled={true}
            placeholder="Report section from Power BI"
            isFocused={focusedFields.visualDescription}
          />
        </Box> */}
      </Box>
    </SectionCard>
  );
};

export default EditQueryBasicInfoSection;
